// Minutes of finished video, as typed (OUT-4; docs/OUTPUT-C5-v1.md §2, rulings D and I): the script editor's Minutes
// field and a Riff card's Minutes. Blank means "use the estimate" on a script (spoken words ÷ 250, the API's
// lib/wordCount.js estimateMinutes) and "not set" on a Riff card. No imports, so tests/runtimeMinutes.test.mjs runs it.

export const RUNTIME_WPM = 250;   // the API's WORDS_PER_MINUTE for a script's minutes (not the editor's read-aloud WPM)

// The API's bounds (routes/scripts.js parseRuntime, routes/liveProduction.js checkCardRuntime): '' clears (null);
// otherwise a number above 0 and at most 600, to one decimal. Returns { value } or { error }.
export function parseMinutes(text) {
  const t = String(text ?? '').trim();
  if (t === '') return { value: null };
  const n = Number(t);
  if (!Number.isFinite(n) || n <= 0 || n > 600) return { error: 'Minutes must be a number above 0, up to 600. Leave it blank to use the estimate.' };
  return { value: Math.round(n * 10) / 10 };
}

// spoken words → minutes, one decimal (the same rounding as the API's estimate)
export const estimateMinutes = words => Math.round(((words || 0) / RUNTIME_WPM) * 10) / 10;

// The field's placeholder: "≈ 36" (whole minutes from 10 up, one decimal below), or '' with nothing to estimate.
export function estimateLabel(words) {
  const m = estimateMinutes(words);
  if (!(m > 0)) return '';
  return `≈ ${m >= 10 ? Math.round(m) : m}`;
}

// What the field shows for a stored value: '' for null, else the number as stored ("10", "2.5").
export const minutesText = v => (v == null ? '' : String(v));
